import React from "react";
// import { Card, Container, Row, Col,Button } from "react-bootstrap";
import "./project.css";
import ProjectBar from "./projectBar";
import projectdata from "../../projectData.js";

const Project = () => {
  return (
    <section id="projects">
      <h2 className="projectTitle">My Projects</h2>
      <div className="projectBars">
        {projectdata.map((item) => {
          return (
            <ProjectBar
              key={item.id}
              projectName={item.projectName}
              projectDescription={item.projectDescription}
              projectLink={item.projectLink}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Project;
